import type { Marker, Geofence, GeofenceEvent } from '../../shared/wire';

interface TeamState {
  markers: Marker[];
  geofences: Geofence[];
  events: GeofenceEvent[];
  lastNow: number;                   // server `now` from the last successful console fetch
  lastSeenObservedAt: number | null; // breach seen-baseline; null until the first fetch seeds it
  seeded: boolean;                   // a first successful fetch happened (suppresses toast-on-load)
  role: 'owner' | 'participant' | null; // caller's group-claim role; null until a fetch seeds it
}
export const team: TeamState = {
  markers: [], geofences: [], events: [],
  lastNow: 0, lastSeenObservedAt: null, seeded: false, role: null,
};
